<template>
  <StockForm :stock="$store.state.stocks.stock" :onSubmit="submit"></StockForm>
</template>

<script>
import StockForm from './StockForm.vue';
import { busEvent } from '../../../main';
import { mapActions } from 'vuex';

export default {
  name: 'CreateStock',
  components: {
    StockForm,
  },
  methods: {
    ...mapActions('stocks', ['create']),
    async submit() {
      await this.create(this.$route.params.productId);
      busEvent.$emit('succesPopupCreated', 'Stockul a fost creat');
      this.$router.push({
        name: 'Stocuri',
        params: { productId: this.$route.params.productId },
      });
    },
  },
};
</script>
